import { UntypedFormGroup } from '@angular/forms';
import {
  NextDisplayView,
  PageHeader
} from '../../login-authentication-screen/models/login-credentials.interface';

export interface ForgotLoginScreenContent {
  formGroup: UntypedFormGroup;
  forgotLoginAttributes: ForgotLoginAttributes;
  forgotLoginContent: ForgotLoginContent;
  errorCode?: string | undefined;
  errorMessage?: string;
  disableButton?: boolean;
}

export interface ForgotLoginContent {
  emailLabel: string;
  emailText: string;
  firstNameLabel: string;
  firstNameText: string;
  headerSubTitle: string;
  headerTitle: string;
  lastNameLabel: string;
  lastNameText: string;
  emailAddressInfoContent: string;
  nextDisplayView: NextDisplayView;
  viewName: string;
  pageHeader: PageHeader;
  errors: ForgotLoginErrorMessages;
}

export interface ForgotLoginAttributes {
  errorCount: number;
  submitAttempt?: boolean;
  errorAlertBanner: boolean;
  firstNameControlTouched: boolean;
  isMfa: boolean;
  lastNameControlTouched: boolean;
  emailIdControlTouched: boolean;
  showFormAlert?: boolean;
}

export interface ForgotLoginErrorMessages {
  emailIdErrorMessage: string;
  firstNameErrorMessage: string;
  lastNameErrorMessage: string;
  forgotLoginAlertWarning: string;
  formAlertErrorMessage?: string;
}

export interface ForgotLoginHeaderContent {
  logoUrl: string;
  altText: string;
  headerTitle: string;
  headerSubTitle: string;
}
